<template>
  <div class="amap-wrapper">
    <el-amap
      class="amap-box"
      vid="task-amap"
      :amap-manager="amapManager"
      :zoom="12"
      :center="center"
      :expand-zoom-range="true"
    />
  </div>
</template>

<script>
import { AMapManager } from "vue-amap";
const amapManager = new AMapManager();
let map, polyline;

const paths = [
  {
    name: "京味斋烤鸭店",
    position: [116.462483, 39.992492],
    zooms: [10, 20],
    opacity: 1,
    zIndex: 4,
    icon: {
      type: "image",
      image: "https://a.amap.com/jsapi_demos/static/images/poi-marker.png",
      clipOrigin: [547, 92],
      clipSize: [50, 68],
      size: [25, 34],
      anchor: "bottom-center",
      angel: 0,
      retina: true,
    },
    text: {
      content: "京味斋烤鸭店",
      direction: "top",
      offset: [0, 0],
      style: {
        fontSize: 13,
        fontWeight: "normal",
        fillColor: "#fff",
        padding: [2, 5, 2, 5],
        backgroundColor: "#22884f",
      },
    },
    extData: {
      index: 6,
    },
  },
  {
    name: "山西刀削面",
    position: [116.472881, 39.997064],
    zooms: [10, 20],
    zIndex: 2,
    opacity: 1,
    icon: {
      type: "image",
      image: "https://a.amap.com/jsapi_demos/static/images/poi-marker.png",
      clipOrigin: [723, 92],
      clipSize: [50, 68],
      size: [25, 34],
      anchor: "bottom-center",
      angel: 0,
      retina: true,
    },
    text: {
      content: "山西刀削面",
      direction: "top",
      offset: [0, 0],
      style: {
        fontSize: 13,
        fontWeight: "normal",
        fillColor: "#fff",
        padding: [2, 5, 2, 5],
        backgroundColor: "#b1009b",
      },
    },
    extData: {
      index: 8,
    },
  },
];
export default {
  data: () => ({
    amapManager,
    center: [121.5273285, 31.21515044],
  }),
  created() {
    setTimeout(() => {
      this.drawLine();
    }, 1000);
  },
  methods: {
    drawLine() {
      const lineArr = [
        [114.758903, 25.678119],
        [114.757093, 25.66076],
        [114.788133, 25.621219],
      ];

      if (!map) {
        map = amapManager.getMap();
      }
      if (polyline) {
        polyline.setMap(null);
      }
      polyline = new AMap.Polyline({
        map: map,
        path: lineArr,
        showDir: true,
        strokeColor: "#28F", //线颜色
        strokeWeight: 6, //线宽
      });
      map.setFitView();
    },
  },
};
</script>

<style>
.amap-box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>